import { IMessageService } from './IMessageService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserInstances } from '../../../models/Account/UserInstancesEntity';
import { MessageEntity } from '../../../models/Messages/MessageEntity';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';

@Injectable({
  providedIn: 'root'
})
export class MessageService implements IMessageService {
  constructor(private httpService: HttpRequestService) { }

  /* Gets UserSites Details */
  GetUserSites(): Observable<UserInstances[]> {
    return this.httpService.GetHttpRequest(apiURLs.MessageAPI.GetUserSites);
  }

  /* Gets Messages */
  GetMessages(searchText: string, MessageCount: number = 0, value?: any): Observable<MessageEntity[]> {

    const params = {
      "MessageFolderId":1,
      "UserId": parseInt(sessionStorage.getItem('loggedInUserId'), 10),
      "TotalUnReadCount": 0,
      "FromDate":null,
      "ToDate":null,
      "FetchAll":false,
      "Skip": 0,
      "Take":50 + MessageCount,
      "GetTotalRecCount":true,
      "TotalCount":0,
      "SearchText":searchText,
      "LookupField":"Subject",
      "ShowReadOnly":false,
      "ShowUnReadOnly":false,
      "IsActiveOnly":true,
      "OrderByColumn":"MR.Id",
      "OrderByDirection":2,
      "MessageRecipientCategoryIds":value};
    return this.httpService.postHttpRequest(apiURLs.MessageAPI.GetMessages, params);
  }

  /*Post Message*/
  PostMessage(entity: MessageEntity): Observable<ValidationEntity> {
    return this.httpService.postHttpRequest(apiURLs.MessageAPI.PostMessages, entity);
  }

  /*Delete Message*/
  DeleteMessage(MessageIds: any): Observable<ValidationEntity> {
    return this.httpService.postHttpRequest(apiURLs.MessageAPI.DeleteMessages, MessageIds);
    // let inputParams = new HttpParams().set("messageIds", siteId.toString()).set("messageType", messageType.toString());
   // return this.httpService.postHttpRequest(apiURLs.MessageAPI.DeleteMessages, messageIds);
  }

  /*Update Message*/
  UpdateMessage(MessageId: number[]): Observable<ValidationEntity> {
    const payload = {
      IsDeleted: false,
      IsRead: true,
      MessageRecipientDetailIds: [MessageId]
    }
    return this.httpService.postHttpRequest(apiURLs.MessageAPI.UpdateMessages, payload);
    // let inputParams = new HttpParams().set("messageIds", siteId.toString()).set("messageType", messageType.toString());
    // return this.httpService.postHttpRequest(apiURLs.MessageAPI.DeleteMessages, messageIds);
  }

  AttachMentsList(URL: string){
    return this.httpService.GetHttpRequest(URL);
  }
  downloadFiles(URL: string, CustomHeaderOptions ){
    return this.httpService.GethttpBlobMethod(URL,CustomHeaderOptions);
  }
}
